/**
 * Location utilities for Greidi
 * GPS-based area detection using Haversine distance formula
 */

// Area -> approximate center coordinates [lat, lng]
// Same mapping used by SearchScreen for map pins
const AREA_COORDS = {
  "Höfuðborgarsvæðið": [64.135, -21.895],
  "Akureyri": [65.683, -18.089],
  "Reykjanesbær": [63.998, -22.563],
  "Selfoss": [63.933, -20.997],
  "Ísafjörður": [66.074, -23.131],
  "Akranes": [64.322, -22.069],
  "Vestmannaeyjar": [63.437, -20.270],
};

/**
 * Haversine distance between two GPS coordinates (in km)
 */
function haversineDistance(lat1, lng1, lat2, lng2) {
  const R = 6371; // Earth radius in km
  const toRad = (deg) => (deg * Math.PI) / 180;

  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

/**
 * Find the nearest area to the given GPS coordinates
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @returns {{ area: string, distance: number }} Nearest area name and distance in km
 */
export function getNearestArea(lat, lng) {
  let nearest = null;
  let minDist = Infinity;

  for (const [area, coords] of Object.entries(AREA_COORDS)) {
    const dist = haversineDistance(lat, lng, coords[0], coords[1]);
    if (dist < minDist) {
      minDist = dist;
      nearest = area;
    }
  }

  return { area: nearest, distance: Math.round(minDist) };
}

export { AREA_COORDS, haversineDistance };
